import { Suspense } from 'react';
import ReactDOM from 'react-dom';
import App from './App';
import './common/index.scss';


const app = document.getElementById("app");
ReactDOM.render(
    <Suspense fallback={<>Loading...</>}>
        <App />
    </Suspense>
, app);